import apiErrorHandler from '@/libraries/apiErrorHandler';
import FbaApiError from '@/types/FbaApiError';
import {
    VirtualRedTagEligibilityRequest,
    VirtualRedTagEligibilityResponse,
} from '@/types/VirtualRedTagEligibility';
import axios from 'axios';

export default async function getVirtualRedTagEligibility(
    dto: VirtualRedTagEligibilityRequest
): Promise<VirtualRedTagEligibilityResponse | FbaApiError> {
    try {
        const response = await axios({
            url: `${process.env.VUE_APP_EXT_API_URL}api/virtualRedTag/eligibility`,
            method: 'POST',
            data: {
                scannedId: dto.scannedQrId,
                trailerId: dto.trailerCompositeId,
                driverCompany: dto.driverCompany,
                assetDriverId: dto.driverId,
                reportedLocation: dto.reportedLocation,
            },
        });

        return response.data as VirtualRedTagEligibilityResponse;
    } catch (error) {
        return apiErrorHandler(error);
    }
}
